// Create a custom fetcher with our API configuration
export const useAPI = () => {
  const config = useRuntimeConfig();
  const authStore = useAuthStore();

  // Create a configured instance of $fetch
  const apiFetch = $fetch.create({
    baseURL: config.public.APIBaseURL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    async onRequest({ options }: { options: { headers: Headers; body?: any } }) {
      // If the body is a FormData instance, remove the Content-Type header
      if (options.body instanceof FormData) {
        options.headers.delete('Content-Type');
      }
      // Add auth header if token exists
      const accessToken = await authStore.getToken();
      if (accessToken) {
        options.headers = new Headers({
          ...Object.fromEntries(options.headers.entries()), // Convert existing Headers to an object
          authorization: `Bearer ${accessToken}`,
        });
      }
    },
    async onResponseError({ response }) {
      // Try to get detailed error message from response body
      let errorBody = null;
      try {
        errorBody = await response.json();
      } catch {
        // Response body might not be JSON
      }

      console.error(`API Error ${response.status}: ${response.statusText}`);

      if (response.status === 401) {
        // Handle unauthorized - could redirect to login
        await navigateTo('/');
      }

      // Create more detailed error message
      const errorMessage = errorBody?.message?.join(' ') || response.statusText;
      const fullError = `API Error (${response.status}): ${errorMessage}`;

      throw new Error(fullError);
    },
  });

  return apiFetch;
};
